import React from 'react';
import { Link } from 'react-router-dom';
import { FiCalendar, FiUser, FiArrowRight } from 'react-icons/fi';
import { blogPosts } from '../data/blogPosts';
import SafeIcon from '../common/SafeIcon';
import SEO from '../components/SEO';

export default function BlogIndex({ lang }) {
  const t = {
    en: {
      title: "Barberà Fit Blog",
      description: "Expert advice on nutrition, training, and lifestyle for the Barberà del Vallès CrossFit community.",
      readMore: "Read More",
      backHome: "Back to Home"
    },
    es: {
      title: "Blog de Barberà Fit",
      description: "Consejos expertos sobre nutrición, entrenamiento y estilo de vida para la comunidad de CrossFit en Barberà del Vallès.",
      readMore: "Leer Más",
      backHome: "Volver al Inicio"
    }
  }[lang];

  return (
    <div className="min-h-screen pb-20">
      <SEO 
        title={t.title} 
        description={t.description} 
        lang={lang} 
        path="/blog"
      />
      
      <main className="max-w-5xl mx-auto px-6 py-12">
        <header className="mb-16 space-y-4">
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-none">
            {t.title}
          </h1>
          <div className="h-1.5 w-24 bg-orange-600"></div>
          <p className="text-xl text-slate-400 max-w-2xl italic">
            {t.description}
          </p>
        </header>

        <div className="grid gap-8 md:grid-cols-2">
          {blogPosts.map((post) => (
            <article 
              key={post.id} 
              className="bg-slate-900/50 weathered-border p-8 flex flex-col group hover:bg-slate-900 transition-all duration-300"
            >
              <div className="flex items-center gap-4 text-xs font-bold text-orange-500 uppercase tracking-widest mb-6">
                <span className="flex items-center gap-1">
                  <SafeIcon icon={FiCalendar} />
                  {post.date}
                </span>
                <span className="text-slate-700">•</span>
                <span className="flex items-center gap-1">
                  <SafeIcon icon={FiUser} />
                  {post.author}
                </span>
              </div>

              <h2 className="text-3xl font-bold text-white mb-4 group-hover:text-orange-500 transition-colors leading-tight">
                {lang === 'en' ? post.titleEN : post.titleES}
              </h2>

              <p className="text-slate-400 mb-8 line-clamp-3 leading-relaxed">
                {lang === 'en' ? post.excerptEN : post.excerptES}
              </p>

              <div className="mt-auto">
                <Link 
                  to={`/blog/${post.slug}`}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-slate-800 text-white font-bold uppercase tracking-tighter hover:bg-orange-600 transition-all"
                >
                  {t.readMore}
                  <SafeIcon icon={FiArrowRight} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </main>
    </div>
  );
}